import { Component, OnInit, signal, inject } from '@angular/core';
import {AuthSandbox} from '../../../modules/global';
import {first, switchMap} from 'rxjs/operators';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {of} from 'rxjs';
import { ExternalPageContainerComponent } from '../../components/externap-page-container/external-page-container.component';
import { TranslateDirective } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { LoaderComponent } from '../../../modules/shared/components/loader/loader.component';
import { MessageComponent } from '../../../modules/shared/components/message/message.component';
import { ButtonComponent } from '../../../modules/shared/components/buttons/button/button.component';

@Component({
    selector: 'slm-company-activation',
    templateUrl: './company-activation.container.html',
    imports: [ExternalPageContainerComponent, TranslateDirective, NgIf, LoaderComponent, MessageComponent, ButtonComponent, RouterLink]
})
export class CompanyActivationContainer implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly authSandbox = inject(AuthSandbox);

  public invalidMessage = signal<string>(null);

  invalid = false;
  activated = false;

  ngOnInit() {
    this.route.paramMap
      .pipe(
        first(),
        switchMap(params => !params.get('token') ? of('invalid') : this.authSandbox.activate(params.get('token')))
      )
      .subscribe({
        next: (resp) => resp === 'invalid' ? this.invalid = true : this.activated = true,
        error: (error) => {
          this.invalidMessage.set(error?.error?.message || 'LBL_COMPANY.INVALID_ID');
          this.invalid = true;
        }
      });
  }
}
